import { render, staticRenderFns } from "./AllIndex.vue?vue&type=template&id=ac3b3228&scoped=true"
import script from "./AllIndex.vue?vue&type=script&setup=true&lang=js"
export * from "./AllIndex.vue?vue&type=script&setup=true&lang=js"
import style0 from "./AllIndex.vue?vue&type=style&index=0&id=ac3b3228&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ac3b3228",
  null
  
)

export default component.exports